const memoizer = require('../request-handler/utils/memoizer');

function serviceFactory({ api }) {
 
  const getFetchUserList = memoizer()((metaData) =>
    api.getFetchUserList(metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
        return null;
    })
  );

  const getFetchChatHistory = memoizer()((inputs, metaData) =>
    api.getFetchChatHistory(inputs, metaData).then((response) => {
     if(!response) return null;
      return JSON.stringify(response);
    }).catch((error) => {
        return null;
    })
  );

  return {
    getFetchUserList,
    getFetchChatHistory
  };
}

module.exports = serviceFactory;